import { render, staticRenderFns } from "./TranslationSettings.vue?vue&type=template&id=3235f13b&scoped=true"
import script from "./TranslationSettings.vue?vue&type=script&lang=js"
export * from "./TranslationSettings.vue?vue&type=script&lang=js"
import style0 from "./TranslationSettings.vue?vue&type=style&index=0&id=3235f13b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3235f13b",
  null
  
)

export default component.exports